<script setup lang="ts">
// `role="status"` pour annoncer le changement de total aux lecteurs d'écran.
defineProps<{
  loading?: boolean;
}>();

const { t } = useI18n();

const loadingLabel = computed(() => t("ui.loading").replace(/[.…]+$/, ""));
</script>

<template>
  <p role="status" :aria-busy="loading || undefined" class="flex items-center gap-2 font-semibold whitespace-nowrap">
    <template v-if="loading">
      <span>{{ loadingLabel }}<span class="inline-block min-w-[1.2em]" aria-hidden="true"><span class="animate-[loading-dot_1.6s_infinite_step-end] opacity-0 motion-reduce:animate-none motion-reduce:opacity-100">.</span><span class="animate-[loading-dot-2_1.6s_infinite_step-end] opacity-0 motion-reduce:animate-none motion-reduce:opacity-100">.</span><span class="animate-[loading-dot-3_1.6s_infinite_step-end] opacity-0 motion-reduce:animate-none motion-reduce:opacity-100">.</span></span></span>
    </template>
    <slot v-else />
  </p>
</template>

<style>
@keyframes loading-dot {
  0% { opacity: 0; }
  25% { opacity: 1; }
}
@keyframes loading-dot-2 {
  0% { opacity: 0; }
  50% { opacity: 1; }
}
@keyframes loading-dot-3 {
  0% { opacity: 0; }
  75% { opacity: 1; }
}
</style>
